import React, { useEffect, useState, useRef } from "react";
import { Container, Button, Dropdown, DropdownButton, Form, InputGroup, Row, Badge, Label, Table, Tooltip, Spinner, OverlayTrigger, FormControl } from 'react-bootstrap';
import { ContributionService } from '../../../services/ContributionService';
import { ClientService } from '../../../services/ClientService';
import Pagination from '../../../components/pagination/Pagination';
import './ClientListInput.scss';
import ErrorManager from "../../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../../services/GlobalProvider";
import { getFormErrorMsg, useOuterClick, currencyFormat, granted } from '../../../helper/Helper'

const ClientListInput = (props) => {

    const [selectedClient, setSelectedClient] = useState()
    const [currentPagination, setCurrentPagination] = useState(1)
    const [isGetClientsLoading, setIsGetClientsLoading] = useState(false)
    const [clientsError, setClientsError] = useState()
    const [clients, setClients] = useState()
    const [clientLoading, setClientLoading] = useState(false)
    const [isPanelOpen, setIsPanelOpen] = useState(false)
    const [activeRowIndex, setActiveRowIndex] = useState(1)
    const [globalError, setGlobalError] = useState()
    const [addedClientList, setAddedClientList] = useState([])

    useEffect(() => {
        let idList = []
        addedClientList?.map(c => {
            idList.push(c._id)
        })
        
        props.onClientIdListChange({
            target : {
                name : props.name,
                value : idList
            }
        })

    }, [addedClientList]);

/*     useEffect(() => {
        setAddedClientList([])
        props.onClientIdListChange([])
    }, [props.reset]); */

    const outerClick = useOuterClick(ev => {
        if (isPanelOpen) {
            setIsPanelOpen(false)
        }
    });

    const { parametres, folderDetails, userDetails, grants } = React.useContext(GlobalContext);

    const searchRef = useRef(null);

    let clientsParams = useRef({
        'start': 0,
        'limit': 8,
        'sort': "code",
        'order': "desc"
        // 'filters': props.filters || {}
    });

    function addClient(client) {
        if (!addedClientList.find(f => f._id == client._id)) {
            setAddedClientList(addedClientList => [...addedClientList, client]);
        }
    }

    function showClientList() {
        setIsPanelOpen(true)
        searchRef.current.value = null
        getClients()
    }

    function removeClient(client) {
        setAddedClientList(addedClientList.filter(f => f._id !== client._id));
    }

    function getClients() {
        setIsGetClientsLoading(true)
        setClientsError()
        setActiveRowIndex()
        ClientService.getClients(props.folderId, clientsParams.current).then(res => {
            setIsGetClientsLoading(false)
            setClients(res.data ? res.data.data : null)
            setActiveRowIndex(0)
        }).catch(error => {
            setActiveRowIndex()
            setIsGetClientsLoading(false)
            setClientsError(error)
        });
    }

    function changePagination(p) {
        setCurrentPagination(p)
        clientsParams.current['start'] = (clientsParams.current.limit * p) - clientsParams.current.limit
        getClients()
    }

    let searchTimeOut;
    function changeSearchValue(e) {
        window.clearTimeout(searchTimeOut);
        setIsPanelOpen(true)
        searchTimeOut = window.setTimeout(function () {
            setCurrentPagination(1)
            searchRef.current.value = e.target.value
            clientsParams.current['start'] = 0
            clientsParams.current['search'] = searchRef.current.value
            getClients()
        }, 1000);
    }

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    function handleKeyDown(e) {
        if (activeRowIndex != null && isPanelOpen) {
            const { code } = e;
            switch (code) {
                case "ArrowUp":
                    e.preventDefault();
                    setActiveRowIndex(activeRowIndex != 0 && activeRowIndex - 1)
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    setActiveRowIndex((activeRowIndex < clients?.clients.length - 1) ? activeRowIndex + 1 : activeRowIndex)
                    break;
                case "Enter":
                    e.preventDefault();

                    if (addedClientList.find(f => f._id == clients.clients[activeRowIndex]._id)) {
                        removeClient(clients.clients[activeRowIndex])
                    } else {
                        addClient(clients.clients[activeRowIndex])
                    }

                    break;
                case "Escape":
                    setIsPanelOpen(false)
                    break;
                default:
                    break;
            }
        }
    }

    if (!granted(grants, "clients.consult")) {
        return (
            <div className="bg-gray-100 text-gray-600 p-2 w-100 rounded">
                <em>- Vous n'avez pas les droits pour consulter les clients. -</em>
            </div>
        )
    }

    return (
        <div id="clientListInput" className="position-relative">

            {globalError && (
                <ErrorManager error={globalError} />
            )}

            <div className="position-relative">

                <InputGroup hasValidation={props.isInvalid}>

                    <FormControl
                        isInvalid={props.isInvalid}
                        disabled={props.disabled}
                        className=""
                        type="text"
                        ref={searchRef}
                        onChange={changeSearchValue}
                        placeholder="Rechercher un client"
                    />

                    <OverlayTrigger
                        delay={{ show: 800 }}
                        overlay={
                            <Tooltip>
                                Afficher les clients
                            </Tooltip>
                        }
                    >
                        <Button disabled={props.disabled} onClick={() => showClientList()} variant="secondary">
                            <i className="material-icons i-lg">expand_more</i>
                        </Button>
                    </OverlayTrigger>

                    {props.isInvalid &&
                        <Form.Control.Feedback type="invalid">
                            {props.isInvalid}
                        </Form.Control.Feedback>
                    }

                </InputGroup>

                {isPanelOpen && (
                    <span ref={outerClick} className="drop-container zindex-100 border border-gray-500 rounded p-3 position-absolute top-100 end-0 bg-white shadow-lg">

                        <div className="w-100 mb-3">
                            <i onClick={() => setIsPanelOpen(false)} className="material-icons text-gray-300 fs-4 position-absolute top-0 end-0 me-2 mt-1 cursor-pointer">close</i>
                        </div>

                        {isGetClientsLoading &&
                            <span className="hloader"></span>
                        }

                        {(!isGetClientsLoading && !clients?.clients) &&
                            <em>- Aucun élément trouvé -</em>
                        }

                        {(!isGetClientsLoading && clients?.clients) &&
                            <>
                                <Table size="sm" borderless hover className="rounded">
                                    <thead className="text-uppercase text-gray-600 small">
                                        <tr>
                                            <th>Code</th>
                                            <th>Nom</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {clients?.clients?.map((client, i) => (
                                            <tr onClick={() => addClient(client)} key={client?._id} className={"align-middle cursor-pointer position-relative " + (i == activeRowIndex ? "table-active selected zindex-1 " : "")}>
                                                <td>{client?.code}</td>
                                                <td>{client?.nom}</td>
                                                <td className="text-end">
                                                    {addedClientList.find(f => f._id == client._id) &&
                                                        <Button onClick={() => removeClient(client)} className="ms-2 py-0 px-2" size="sm" variant="danger">Suppr.</Button>
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>

                                <Pagination className="mt-3" size="sm" itemsLength={clients?.total} elementsPerPage={clientsParams.current.limit} currentPagination={currentPagination} changePagination={p => changePagination(p)} />

                            </>
                        }

                    </span>
                )}
            </div>

            {(addedClientList.length > 0) &&
                <div className="mt-2">
                    {addedClientList.map(client => (
                        <span key={client._id} className="d-inline-flex align-items-center bg-gray-100 rounded me-2 mb-2 p-1 small border">
                            <span className="me-2 text-gray-700">
                                {client.code} - {client.nom}
                            </span>
                            <span onClick={() => removeClient(client)} className="px-1 bg-gray-300 hover-bg-gray-400 rounded cursor-pointer">
                                <i className="material-icons ">
                                    close
                                </i>
                            </span>
                        </span>
                    ))}
                </div>
            }

        </div>

    )
}
export default ClientListInput;
